import { bpHistory } from 'global/bpHistory';
import { TabId, ElectionsTabId, TabIdWithElections } from 'store/modules/full-employee-form/types';
import { EmployeeActionObject } from 'store/modules/add-employees/actionRules';
import { generatePath } from 'react-router-dom';
import { ROUTES_CONFIG_V2, RouteV2Id } from 'routes/routesConfigV2';

function quoteEmployeeFormQuery(context: {
  groupId: string;
  periodId: string;
  cartId?: string;
  subscriberId: string;
  activeTabId?: TabIdWithElections;
}): string {
  const { groupId, periodId, cartId, subscriberId, activeTabId } = context;
  const params = new URLSearchParams({ subscriberId });
  if (activeTabId) {
    params.set('activeTabId', activeTabId);
  }
  return `${generatePath(ROUTES_CONFIG_V2[RouteV2Id.QUOTE_ADD_EMPLOYEES_FULL_FORM].path, {
    groupId,
    periodId,
    cartId,
  })}?${params.toString()}`;
}

export enum QuoteChecklistEmployeeAction {
  QUOTE_CHECKLIST_EMPLOYEE_PROFILE = 'QUOTE_CHECKLIST_EMPLOYEE_PROFILE',
  QUOTE_CHECKLIST_MANAGE_DEPENDENTS = 'QUOTE_CHECKLIST_MANAGE_DEPENDENTS',
  QUOTE_CHECKLIST_INTERESTED_PRODUCT_LINES = 'QUOTE_CHECKLIST_INTERESTED_PRODUCT_LINES',
}

export const quoteChecklistEmployeeActions: EmployeeActionObject[] = [
  {
    type: QuoteChecklistEmployeeAction.QUOTE_CHECKLIST_EMPLOYEE_PROFILE,
    name: 'Employee Profile',
    handler: (context): void => {
      bpHistory.push(
        quoteEmployeeFormQuery({
          groupId: context.static.groupId,
          periodId: context.static.periodId,
          cartId: context.static.cartId,
          subscriberId: context.static.employeeData.id,
        }),
      );
    },
  },
  {
    type: QuoteChecklistEmployeeAction.QUOTE_CHECKLIST_MANAGE_DEPENDENTS,
    name: 'Manage Dependents',
    handler: (context): void => {
      bpHistory.push(
        quoteEmployeeFormQuery({
          groupId: context.static.groupId,
          periodId: context.static.periodId,
          cartId: context.static.cartId,
          subscriberId: context.static.employeeData.id,
          activeTabId: TabId.DEPENDENTS,
        }),
      );
    },
  },
  {
    type: QuoteChecklistEmployeeAction.QUOTE_CHECKLIST_INTERESTED_PRODUCT_LINES,
    name: 'Manage Elections',
    handler: (context): void => {
      bpHistory.push(
        quoteEmployeeFormQuery({
          groupId: context.static.groupId,
          periodId: context.static.periodId,
          cartId: context.static.cartId,
          subscriberId: context.static.employeeData.id,
          activeTabId: ElectionsTabId.ELECTIONS,
        }),
      );
    },
  },
];
